<template>
  <div class="fondo-polaroid">
    <div class="overlay"></div>

    <!-- MARCO -->
 
    <!-- TEXTO DE INVITACIÓN -->
    <p ref="textoRef" class="texto-invitacion">
      Con todo nuestro amor, nuestra invitación
    </p>

    <!-- SOLO FALTAN + CONTADOR -->
    <div class="contador-contenedor" ref="contadorRef">
      <br />
      <p class="solo-faltan" ref="soloFaltanRef">¡Solo faltan!</p><br />
      <p class="texto-countdown" ref="countdownRef">{{ countdown }}</p>
    </div>


        <!-- Ramita decorativa central -->
    <img
      ref="ramitaRef"
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-decorativa"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PolaroidGallery',
  setup() {
    const imagenes = [
      new URL('@/assets/PP.jpg', import.meta.url).href,
      new URL('@/assets/IMG_7905-4.jpg', import.meta.url).href,
      new URL('@/assets/IMG_7927.jpg', import.meta.url).href,
    ]

    const currentImage = ref(imagenes[0])
    let index = 0

    const textoRef = ref(null)
    const countdown = ref('')
    const countdownRef = ref(null)
    const soloFaltanRef = ref(null)
    const contadorRef = ref(null)

    const fechaEvento = new Date('2025-10-18T16:00:00')

    const actualizarContador = () => {
      const ahora = new Date()
      const diferencia = fechaEvento - ahora

      if (diferencia <= 0) {
        countdown.value = '¡Hoy es el gran día!'
        return
      }

      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24))
      const horas = Math.floor((diferencia / (1000 * 60 * 60)) % 24)
      const minutos = Math.floor((diferencia / (1000 * 60)) % 60)
      const segundos = Math.floor((diferencia / 1000) % 60)

      countdown.value = `${dias} días · ${horas}h · ${minutos}m · ${segundos}s`
    }

    let intervalId

    onMounted(() => {
      // Carrusel
      setInterval(() => {
        index = (index + 1) % imagenes.length
        currentImage.value = imagenes[index]
      }, 2000)

      // Animación texto invitación
      const observerText = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          gsap.fromTo(
            textoRef.value,
            { opacity: 0, y: 60, rotateZ: -5 },
            {
              opacity: 1,
              y: 0,
              rotateZ: 0,
              duration: 1.6,
              ease: 'power4.out',
            }
          )
          observerText.disconnect()
        }
      }, { threshold: 0.5 })

      if (textoRef.value) observerText.observe(textoRef.value)

      // Animaciones "¡Solo faltan!" y contador
      const observerContador = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          gsap.fromTo(soloFaltanRef.value,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }
          )
gsap.fromTo(countdownRef.value,
  {
    opacity: 0,
    y: -100,
    scaleY: 0.6,
    scaleX: 1.1,
    transformOrigin: '50% 0%'
  },
  {
    opacity: 1,
    y: 0,
    scaleY: 1,
    scaleX: 1,
    duration: 1.2,
    ease: 'circ.out',
    delay: 0.3,
    onStart: () => {
      // Efecto de onda
      gsap.to(countdownRef.value, {
        scaleX: 0.95,
        duration: 0.15,
        repeat: 1,
        yoyo: true
      })
    }
  }


          )

          observerContador.disconnect()
        }
      }, { threshold: 0.4 })

      if (contadorRef.value) observerContador.observe(contadorRef.value)

      // Iniciar contador
      actualizarContador()
      intervalId = setInterval(actualizarContador, 1000)
    })

    onUnmounted(() => {
      clearInterval(intervalId)
    })

    return {
      currentImage,
      textoRef,
      countdown,
      countdownRef,
      soloFaltanRef,
      contadorRef
    }
  }
}
</script>
<style>
body {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  background: #f4f4f4;
}
</style>

<style scoped>
.fondo-polaroid {
  width: 80vw;
  max-width: 900px;
  height: 70vh;
  max-height: 600px;
margin-top:-80px;
  border-radius: 16px;

  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* fallback por si el body‑flex no llegara a aplicarse */
  margin-inline: auto;
}

.fondo-imagen {
  position: absolute;
  width: 80%;
  height: 90%;
  object-fit: cover;
  z-index: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.marco-polaroid {
  position: relative;
  width: 330px;
  padding: 12px;
  background-color: white;
  border: 12px solid white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  z-index: 2;
  text-align: center;
}

.foto-polaroid {
  width: 100%;
  display: block;
  border: none;
  object-fit: cover;
}

.texto-invitacion {
  z-index: 2;
  margin-top: 20px;
  font-family: 'say2', cursive;
  font-size: 20px;
  color: rgb(179, 172, 172);
  padding: 10px 20px;
  border-radius: 8px;
  text-align: center;
  transform-origin: bottom center;
}

/* CONTADOR */
.contador-contenedor {
  z-index: 2;
  text-align: center;
  margin-top: 20px;
}

.solo-faltan {
  font-family: 'say2', cursive;
  font-size: 28px;
  color: rgb(156, 149, 149);
  margin-bottom: 5px;
}

.texto-countdown {
  z-index: 2;
  font-family: 'padres';
  font-size: 16px;
  color: rgb(179, 172, 172);
  padding: 5px 5px;
  border-radius: 8px;
  text-align: center;
  letter-spacing: 1px;
  word-spacing: 12px;
  display: inline-block;
}
.ramita-decorativa {
  width: 80px;
  height: auto;
  margin: 30px 0;
  transform-origin: center;
  opacity: 1;
}
</style>
